import { render, staticRenderFns } from "./FlowInputs.vue?vue&type=template&id=536572d2&scoped=true&"
import script from "./FlowInputs.vue?vue&type=script&lang=js&"
export * from "./FlowInputs.vue?vue&type=script&lang=js&"
import style0 from "./FlowInputs.vue?vue&type=style&index=0&id=536572d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536572d2",
  null
  
)

export default component.exports